import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Authentication flows exclusively through httpOnly cookies set by the backend
// on /auth/login, /auth/register, /auth/refresh, and /auth/google/session.
// `withCredentials: true` ensures the browser attaches those cookies to every
// call (both from axios and from <img src> / <iframe src> requests to /api).
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

/** URL helper for file endpoints — cookies handle auth, no query token needed. */
export function fileUrl(fileId, variant) {
  if (!fileId) return "";
  const q = variant ? `?variant=${encodeURIComponent(variant)}` : "";
  return `${API}/files/${fileId}${q}`;
}

/** Retry once on 401 by asking the backend to refresh, then bail. */
let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const original = err.config;
    if (err.response?.status === 401 && !original._retry && !original.url?.includes("/auth/")) {
      original._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(original);
      } catch {
        refreshing = null;
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
